export default "__VITE_ASSET__Cm0ZPN4J__"